/**
 * This file is auto-generated, please do not edit it manually.
 */
import * as React from 'react';
export function IcWarningMd(props) {
    return (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { d: "M20.634 16.125l-6.25-10.986c-1.054-1.852-3.714-1.852-4.768 0l-6.25 10.986c-1.046 1.838.276 4.125 2.383 4.125H18.25c2.109 0 3.43-2.287 2.384-4.125zM12 7.5a.75.75 0 01.75.75v5.25a.75.75 0 01-1.501 0V8.25c0-.414.337-.75.75-.75zM12 18a1.125 1.125 0 110-2.25A1.125 1.125 0 0112 18z", fill: "currentColor" }))));
}
//# sourceMappingURL=IcWarningMd.js.map